import i18n from './locales/i18n'

export const A_SIGNEDIN = 1
export const A_REQUEST = 2
export const A_SUBSTITUTE = 3
export const A_SIGNEDOUT = 4
export const A_MISSED = 5

export const A_PERMISSION_PUBLIC = 1
export const A_PERMISSION_INVITED = 2
export const A_PERMISSION_INVITED_REQUEST = 3

export const A_QUESTION_TEXT = 1
export const A_QUESTION_SINGLE_OPT = 2
export const A_QUESTION_MULTI_OPT = 3

export const I_DEFAULT = 1
export const I_ACCEPTED = 2
export const I_REJECTED = 3

export const E_CANCELLED = 3

export const ROLE_ADMIN = 1
export const ROLE_OSTRAVA_ADMIN = 3
export const ROLE_CHEB_ADMIN = 4

export const RESOURCE_WEBSITE = 1
export const RESOURCE_FACEBOOK = 2
export const RESOURCE_INSTAGRAM = 3

export const EVENT_TAG_TOP = 1
export const EVENT_TAG_FOR_CHILDREN = 2
export const EVENT_TAG_FOR_SPECTATORS = 3
export const EVENT_TAG_FOR_ATHLETES = 4
export const EVENT_TAG_LANDING = 5
export const EVENT_TAG_ONLINE = 6

export const EVENT_FORM_TAG_ONLINE = 'online'

export const ATTENDANCE_VISIBILITY_PUBLIC = 1
export const ATTENDANCE_VISIBILITY_ATTENDEES = 4

export const S_RELATION_CONDUCT = 1
export const S_RELATION_TRAIN = 2
export const S_RELATION_CHEER = 3
export const S_RELATION_CHILD = 4
export const S_RELATION_REFEREE = 5

export const TYPE_ACTUALITY = 1
export const TYPE_SLIDESHOW = 2

export const EVENT_TYPE_OTHER = 7

export const EVENT_TYPE_DEFAULT_DATA = {
    0: {
        button: 'Event__lookup-status-0',
        text: i18n.t('allEventTypes'),
        subtext: null,
        selected: true,
    },
}

export const RECRUITMENT_LOOKUP = {
    'girls': 'Dívky',
    'boys': 'Chlapci',
    'men': 'Muži',
    'women': 'Ženy',
}

export const S_SPORTNECT = 'sportnect'
export const S_SPORTUJ_V_OSTRAVE = 'sportuj_v_ostrave'
export const S_SPORTUJ_V_OLOMOUCI = 'sportuj_v_olomouci'
export const S_SPORTUJ_V_CHEBU = 'sportuj_v_chebu'

export const SYSTEM_BY_ROLE_ID = {
    3: S_SPORTUJ_V_OSTRAVE,
    4: S_SPORTUJ_V_CHEBU,
}

export const SUPER_ADMIN_ROUTE = '/super-admin'

export const COMPETITION_MATCH = 1
export const FRIENDLY_MATCH = 2
export const TRAINING = 3
export const RECRUITMENT = 4
export const TOURNAMENT_EVENT = 5
export const LEAGUE_EVENT = 11

export const DESCRIPTION_MAX_LENGTH = 10000

export const DESCRIPTIONS_MAX_LENGTH = 20000
export const DESCRIPTIONS_MIN_LENGTH = 1
export const DESCRIPTIONS_TITLE_MAX_LENGTH = 30

export const RESPONSIVE_WIDTH = 768
export const RESPONSIVE_LG_WIDTH = 1200

export const BASE_NUMBER_OF_CHEERS_MODAL = 50

export const FILTER_SHOWED_ITEMS = 5

export const FRIENDSHIP_STATE_PENDING = 1
export const FRIENDSHIP_STATE_ACCEPTED = 2
export const FRIENDSHIP_STATE_DECLINED = 3
export const FRIENDSHIP_STATE_REMOVED = 4

export const GROUP_TYPES = {
    '1': 'Sportovní skupina',
    '2': 'Oddíl',
    '3': 'Klub',
    '4': 'Tělovýchovná jednota',
    '5': 'Tým',
    '6': 'Komunita',
    '7': 'Společnost',
    '8': 'Družstvo',
    '9': 'Svaz',
    '10': 'Asociace',
    '11': 'Kategorie',
    '12': 'Jiný',
    '13': 'Akademie',
    '14': 'Škola',
}

export const MOBILE_VIEW = 850

export const EMAIL_INVITATION_DELIMITERS_KEYCODES = [9, 13, 32, 188]

export const DEVICE_IOS = 'ios'
export const DEVICE_ANDROID = 'android'

export const INSTAGRAM_CHECK_PATTERN = '(http://|https://)?(www.)?instagram.com/[a-zA-Z0-9_/?=-]+'

export const ATTENDANCE_PERMISSION_ANYONE = 1
export const ATTENDANCE_PERMISSION_INVITED = 2
export const ATTENDANCE_PERMISSION_INVITED_AND_CAN_REQUEST = 3

export const ATTENDEES_VISIBILITY_ANYONE = 1
export const ATTENDEES_VISIBILITY_PARTICIPANTS_AND_INVITED = 4

export const PASSWORD_MIN_LENGTH = 6
export const PASSWORD_ERROR = 1

export const VALIDATION_ERROR_UNIQUE_EMAIL = 2
export const VALIDATION_ERROR_NONVALID_EMAIL = 3
export const VALIDATION_ERROR_SHORT_PASSWORD = 4

export const SPORT_OTHERS_ID = 35

export const SPORT_VENUES_LIMIT = 1000

export const LOGIN_ERROR_EMAIL_NOT_FOUND = 'user_email_not_found'
export const LOGIN_ERROR_WRONG_PASSWORD = 'wrong_password'
export const LOGIN_ERROR_TOO_MUCH_INVALID_CREDENTIALS = 'too_much_invalid_credentials'

export const MESSENGER_VISIBILITY_ALL = 1
export const MESSENGER_VISIBILITY_SPORTNECTIONS = 2

export const USER_PROFILE_VISIBILITY_PUBLIC = 1
export const USER_PROFILE_VISIBILITY_SPORTNECTIONS = 2
export const USER_PROFILE_VISIBILITY_PRIVATE = 3

export const NUM_LETTERS_DESCRIPTION_TO_EXPAND = 900

export const MESSENGER_STATUS_CAN_MESSAGE = 1

export const EMAIL_ALREADY_EXISTS_API_ERROR = 'Tento email je ve Sportnectu již registrován.'
export const EMAIL_IS_REGISTERED_MESSAGE = 'Tento e-mail je již registrován, přihlaste se'

export const EMAIL_EXISTS = 1
export const EMAIL_NOT_EXISTS = 2
export const EMAIL_NOT_EMAIL = 3
export const EMAIL_NOT_VALID_FORMAT = 4

export const ATTENDANCE_STATES = {
    [A_SIGNEDIN]: {
        label: i18n.t('attendanceStateSignedIn'),
        badge: 'success',
    },
    [A_REQUEST]: {
        label: i18n.t('attendanceStateRequest'),
        badge: 'dark',
    },
    [A_SUBSTITUTE]: {
        label: i18n.t('attendanceStateSubstitute'),
        badge: 'info',
    },
    [A_SIGNEDOUT]: {
        label: i18n.t('attendanceStateSignedOut'),
        badge: 'secondary',
    },
    [A_MISSED]: {
        label: i18n.t('attendanceStateMissed'),
        badge: 'danger',
    },
}

export const INVITATION_STATES = {
    [I_DEFAULT]: {
        label: i18n.t('invitationActive'),
        badge: 'primary',
    },
    [I_ACCEPTED]: {
        label: i18n.t('invitationAccepted'),
        badge: 'success',
    },
    [I_REJECTED]: {
        label: i18n.t('invitationRejected'),
        badge: 'secondary',
    },
}

export const ROSTER_DECLINED_LIMIT = 100

export const ENTITY_LIST_LIMIT_PER_PAGE = 15

export const CHECK_ACCESS_TYPE_OTHER = 0
export const CHECK_ACCESS_TYPE_HOME = 1
export const CHECK_ACCESS_TYPE_EVENT_LIST = 2
export const CHECK_ACCESS_TYPE_EVENT_DETAIL = 3
export const CHECK_ACCESS_TYPE_GROUP_LIST = 4
export const CHECK_ACCESS_TYPE_GROUP_DETAIL = 5
export const CHECK_ACCESS_TYPE_SPORT_VENUE_LIST = 6
export const CHECK_ACCESS_TYPE_SPORT_VENUE_DETAIL = 7
export const CHECK_ACCESS_TYPE_NOTIFICATION = 8
export const CHECK_ACCESS_TYPE_MESSENGER = 9
export const CHECK_ACCESS_TYPE_MESSENGER_THREAD = 10

export const GROUP_MEMBERS_META_ROLE_TYPE = 'roleType'
export const GROUP_MEMBERS_META_ROLE_TYPES = {
    1 : 'headCoach',
    2 : 'coach',
    3 : 'assistantCoach',
    4 : 'player',
    5 : 'defender',
    6 : 'forward',
    7 : 'goalie',
    8 : 'member',
    9 : 'parent',
    10 : 'guest',
    11 : 'elderly',
    12 : 'younger',
    13 : 'youngest',
    14 : 'yellow',
    15 : 'orange',
    16 : 'red',
    17 : 'purple',
    18 : 'blue',
    19 : 'green',
    20 : 'black',
    21 : 'white',
    22 : 'head',
    23 : 'functionary',
    24 : 'goalieCoach',
    25 : 'masseur',
    26 : 'physiotherapist',
}

export const FIREBASE_COLLECTION_KEY_BANNERS = 'banners'
export const FIREBASE_BANNERS_ENTITIES_TYPE = 'type'

export const URL_PARAM_PHOTO_PRIMARY_KEY = 'photoPrimaryKey'
export const PHOTO_FILE_UPLOAD_MAX_SIZE = 5242880 // 5 MB
export const PHOTO_FILE_MAX_SIZE_EXCEEDED_KEY = 'photo_file_max_size_exceeded'

export const REACTIONS = {
    1: {
        id: 1,
        icon: '/images/reactions/point-up.png',
    },
    2: {
        id: 2,
        icon: '/images/reactions/thumbs-up.png',
    },
    3: {
        id: 3,
        icon: '/images/reactions/thumbs-down.png',
    },
    4: {
        id: 4,
        icon: '/images/reactions/smile.png',
    },
    5: {
        id: 5,
        icon: '/images/reactions/cry.png',
    },
    6: {
        id: 6,
        icon: '/images/reactions/trophy.png',
    },
    7: {
        id: 7,
        icon: '/images/reactions/sport-medal.png',
    },
    8: {
        id: 8,
        icon: '/images/reactions/hearth.png',
    },
}

export const FAMILY_RELATIVE_PROPOSED = 'proposed'
export const FAMILY_RELATIONSHIP_CHILD = 'child'

export const FAMILY_ACTION_REJECT = 'rejectFamilyRelationship'
export const FAMILY_ACTION_CONFIRM = 'confirmFamilyRelationship'

export const FILTER_HASHTAGS_STATE = [
    'zamer',
    'priprava',
    'realizace',
    'dokonceno',
]

export const U_RELATION_CANNOT_JOIN = 0
export const U_RELATION_CAN_JOIN = 1
export const U_RELATION_I_INVITED = 2
export const U_RELATION_I_DECLINED = 3
export const U_RELATION_A_REQUEST = 4
export const U_RELATION_A_SIGNEDIN = 5
export const U_RELATION_A_SUBSTITUTE = 6
export const U_RELATION_A_SIGNEDOUT = 7
export const U_RELATION_A_MISSED = 8

export const NON_TRANSLATED_ROUTES = [
    '/cognito/oauth/callback',
]

export const AVAILABLE_LANGUAGES = [
    'cs',
    'en',
    'de',
    'pl',
]

export const ADMIN_PAGES = [
    'attendance',
    'dashboard',
    'managers',
    'members',
    'members-meta',
    'presence',
    'events-calendar',
]

export const DEFAULT_LANGUAGE_CODE = 'cs'

export const SFN_TYPE = '?type=fromSfn'
export const SFN_DEFAULT_SPORT_ID = 1

export const PAYPAL_URL = 'https://www.paypal.com/sdk/js?client-id=AbfST8vwqliACw-y5jzG8z0Lic7W6dOthI5toVd7dDCkYKEMFTwcN94EUeZe2AFrdvkLYabf6nT8FGtB&currency=USD'

export const TIMELINE_POSTS_LIMIT = 5

export const TOURNAMENT_CREATE_URL = 'https://tournaments.sportnect.com/tournaments/create'
export const TOURNAMENT_SUBPAGE_URL = 'https://www.sportnect.com/turnaje?type=fromDashboard'

export const API_CHECKER_STATUS_ONLINE = 'online'
export const API_CHECKER_STATUS_OFFLINE = 'offline'

const { REACT_APP_BUCKET_NAME } = window.APP_CONFIG
export const BUCKET_URL = `https://${REACT_APP_BUCKET_NAME}.s3-eu-west-1.amazonaws.com/public/`